module.exports = __webpack_public_path__ + "static/media/siddharth-fridge.111c736d.jpg";